import { render, staticRenderFns } from "./InvestorPreferences.vue?vue&type=template&id=dbd82416"
import script from "./InvestorPreferences.vue?vue&type=script&lang=js"
export * from "./InvestorPreferences.vue?vue&type=script&lang=js"
import style0 from "./InvestorPreferences.vue?vue&type=style&index=0&id=dbd82416&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports